module.exports = __webpack_public_path__ + "static/media/livedooh-dev-Integrations-2.a1ef7c6d.svg";